module.exports = __webpack_public_path__ + "img/4.d77f4da1.png";